import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=b35b62ac&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=b35b62ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b62ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b35b62ac')) {
      api.createRecord('b35b62ac', component.options)
    } else {
      api.reload('b35b62ac', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=b35b62ac&scoped=true", function () {
      api.rerender('b35b62ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/privacy/ko_KR/privacy.vue"
export default component.exports